import React, {FC} from 'react';

import {Icon, CycleMini} from '@optimaxdev/icons';
import classNames from 'classnames';

import {QuoteItemV2} from 'api/magento/magentoAPI.schemas';

import s from './subscriptionSupplyBlock.scss';

export type PropsType = {
    item: QuoteItemV2;
    isRebate?: boolean;
    children?: React.ReactNode;
    supplyComponent: React.ReactNode;
};

/**
 * Contact lenses subscription block
 */
export const SubscriptionSupplyBlock: FC<PropsType> = ({
    children,
    isRebate = false,
    item,
    supplyComponent,
}) => {
    const {subscription} = item;
    const isSubscription = subscription?.subscriptionMode;

    return (
        <div className={s.subscriptionQuantity}>
            {isSubscription && (
                <p
                    className={classNames(s.subscribed, {
                        [s.subAndRebate]: isRebate,
                    })}
                    aria-label="subscribed"
                >
                    <Icon
                        className={s.repeatIcon}
                        height={16}
                        icon={CycleMini}
                        strokeWidth={2}
                        width={16}
                    />
                    Subscribed
                </p>
            )}
            {children}
            {isSubscription && supplyComponent}
        </div>
    );
};
